import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ahm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const isAuthed = () => Boolean(localStorage.getItem("ahm_admin_token"));

export const login = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  localStorage.setItem("ahm_admin_token", data.token);
  localStorage.setItem("ahm_admin_email", data.email);
  return data;
};

export const logout = () => {
  localStorage.removeItem("ahm_admin_token");
  localStorage.removeItem("ahm_admin_email");
};

/**
 * Upload a file (image or video) from the admin's computer to the server.
 * Returns the absolute URL that can be stored in any image/video field.
 */
export const uploadFile = async (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 0,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return `${BACKEND}${data.path}`;
};

/** Extract the 11-char YouTube video id from any YouTube link (or a bare id). */
export const parseYouTubeId = (input = "") => {
  const s = String(input).trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  const m = s.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return m ? m[1] : "";
};
